import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plus-circle",
  "use": "plus-circle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"plus-circle\">\n  <path fill-rule=\"evenodd\" d=\"M216.927,241.984a7.96,7.96,0,0,0-2.911-2.911,8.05,8.05,0,0,0-8.031,0,7.963,7.963,0,0,0-2.912,2.911,8.052,8.052,0,0,0,0,8.032,7.968,7.968,0,0,0,2.911,2.911,8.052,8.052,0,0,0,8.032,0,7.968,7.968,0,0,0,2.911-2.911,8.052,8.052,0,0,0,0-8.032h0Zm-2.26,4.682a0.676,0.676,0,0,1-.667.667h-2.667V250a0.676,0.676,0,0,1-.666.667h-1.334a0.676,0.676,0,0,1-.666-0.667v-2.667H206a0.676,0.676,0,0,1-.667-0.667v-1.333a0.676,0.676,0,0,1,.667-0.666h2.667V242a0.676,0.676,0,0,1,.666-0.667h1.334a0.676,0.676,0,0,1,.667.667v2.667H214a0.676,0.676,0,0,1,.667.666v1.333Zm0,0\" transform=\"translate(-202 -238)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/plus-circle.svg
// module id = null
// module chunks = 